import React, {useEffect} from 'react';
import {Splide, SplideSlide} from '@splidejs/react-splide';
import SizeGuide from './SizeGuide';
import './../styles/sizeguide.scss';
import './../../../../designsystem/css/shared/carousel.css';

function SizeGuideCarousel() {
    useEffect(() => {
        const track = document.querySelectorAll('.splide__track');
        const list = document.querySelectorAll('.splide__list');
        const slide = document.querySelectorAll('.splide__slide');

        track.forEach(track => track.classList.add('carousel-track'));
        list.forEach(list => list.classList.add('carousel-tray'));
        slide.forEach(slide => slide.classList.add('carousel-item'));
    }, []);

    return (
        <div className="bridle-carousel">
            <Splide
                className="sp-carousel"
                aria-label="Carousel for Bridle Builder Size Guides"
                options={{
                    gap: '2rem',
                    arrowPath: 'M35,20L5,40L5,0L35,20z',
                    throttle: 500,
                    speed: 1000,
                    classes: {
                        arrows: 'splide__arrows carousel-controls',
                        arrow: 'splide__arrow carousel-arrow',
                        prev: 'splide__arrow--prev carousel-arrow carousel-prev',
                        next: 'splide__arrow--next carousel-arrow carousel-next'
                    },
                    arrows: false,
                    drag: false,
                    pagination: false,
                    start: 0,
                    focus: 0,
                    perPage: 4,
                    perMove: 4,
                    breakpoints: {
                        767: {
                            type: 'loop',
                            padding: '2rem',
                            gap: '2rem',
                            perPage: 3,
                            perMove: 1,
                            arrows: true,
                            drag: true
                        },
                        519: {
                            type: 'loop',
                            gap: '1.2rem',
                            perPage: 2,
                            perMove: 1,
                            arrows: true,
                            drag: true
                        }
                    }
                }}
            >
                <SplideSlide>
                    <img
                        className="size-guide-carousel-image"
                        src="https://img.smartpak.com/images/bridlebuilder/SmartFit_Harwich_SizeCharts_Crownpiece.jpg"
                        alt="Click to view Crownpiece size guide"
                        data-modal="#size-guide-for-crownpiece"
                        data-modal-title="Bridle Size Guide"
                    />
                    <div id="size-guide-for-crownpiece" className="jsHide">
                        <SizeGuide type="crownpiece" />
                    </div>
                </SplideSlide>

                <SplideSlide>
                    <img
                        className="size-guide-carousel-image"
                        src="https://img.smartpak.com/images/bridlebuilder/SmartFit_Harwich_SizeCharts_Browband.jpg"
                        alt="Click to view Browband size guide"
                        data-modal="#size-guide-for-browband"
                        data-modal-title="Bridle Size Guide"
                    />
                    <div id="size-guide-for-browband" className="jsHide">
                        <SizeGuide type="browband" />
                    </div>
                </SplideSlide>

                <SplideSlide>
                    <img
                        className="size-guide-carousel-image"
                        src="https://img.smartpak.com/images/bridlebuilder/SmartFit_Harwich_SizeCharts_CheekPiece.jpg"
                        alt="Click to view Cheek Piece size guide"
                        data-modal="#size-guide-for-cheekpiece"
                        data-modal-title="Bridle Size Guide"
                    />
                    <div id="size-guide-for-cheekpiece" className="jsHide">
                        <SizeGuide type="cheekpiece" />
                    </div>
                </SplideSlide>

                <SplideSlide>
                    <img
                        className="size-guide-carousel-image"
                        src="https://img.smartpak.com/images/bridlebuilder/SmartFit_Harwich_SizeCharts_Noseband.jpg"
                        alt="Click to view Noseband size guide"
                        data-modal="#size-guide-for-noseband"
                        data-modal-title="Bridle Size Guide"
                    />
                    <div id="size-guide-for-noseband" className="jsHide">
                        <SizeGuide type="noseband" />
                    </div>
                </SplideSlide>
            </Splide>
        </div>
    );
}

export default SizeGuideCarousel;
